import React from 'react';
import Ev from './img/ev-indication.svg';
import Hybrid from './img/hybrid-ev-indication.svg';

const EvIndicator = (props) => {
  const { assetType } = props;
  const indicator = (value) => {
        switch (value) {
        case 'EV1':
            return <img loading="lazy" src={Ev} alt="indication-icon" />;
        case 'EV2':
            return <img loading="lazy" src={Ev} alt="indication-icon" />;
        case 'Hybrid':
            return <img loading="lazy" src={Hybrid} alt="indication-icon" />;
        default:
            return null;
        }
  };
  return (
    <div>
        {indicator(assetType)}
    </div>
  );
};

export default EvIndicator;
